import moment from 'moment';
import { homeFrontService } from '../network/services/home-front.service';

function formatValues(data) {
  const o = {};
  Object.keys(data).forEach((key) => {
    if (key === 'guestCount') {
      o[key] = parseInt(data[key]);
      return;
    }
    if (['hasInfant', 'isBusiness'].indexOf(key) !== -1) {
      o[key] = ['true', true, 1, '1'].indexOf(data[key]) !== -1;
      return;
    }
    o[key] = data[key];
  });
  return o;
}

export default {
  namespaced: true,
  state: {
    startDate: moment().toDate(),
    endDate: moment().add(1, 'd').toDate(),
    searchString: '',
    guestCount: 2,
    isBusiness: false,
    businessCode: '',
    hasInfant: false,
    results: null,
    isRequesting: false,
  },
  mutations: {
    SET_SEARCH(state, payload) {
      const keys = ['startDate', 'endDate', 'searchString', 'guestCount', 'isBusiness', 'businessCode', 'hasInfant'];
      for (const k of keys) {
        if (payload[k]) {
          state[k] = payload[k];
        }
      }
    },
    SET_REQUESTING(state, payload) {
      state.isRequesting = payload;
    },
    SET_RESULTS(state, payload) {
      state.results = payload;
    },
  },
  actions: {
    async search(context, data) {
      context.commit('SET_SEARCH', formatValues(data));
      context.commit('SET_REQUESTING', true);

      const result = await homeFrontService.searchRoomGroup(data);
      context.commit('SET_RESULTS', result);
      return new Promise((resolve) => {
        setTimeout(() => {
          context.commit('SET_REQUESTING', false);
          resolve();
        }, 60000);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/room-search.store.js